import { useEffect, useState } from "react";
import { memberApi } from "../../lib/api";
import { toast } from "sonner";

const LABEL = { conforme: "Conforme", a_acheter: "À acheter", a_remplacer: "À remplacer", prete_dojo: "Prêté par le dojo", deja_possede: "Déjà possédé", non_requis: "Non requis", a_valider: "À valider par l'instructeur" };
const CLS = { conforme: "text-emerald-300", a_acheter: "text-rose-300", a_remplacer: "text-orange-300", prete_dojo: "text-sky-300", deja_possede: "text-emerald-200", non_requis: "text-white/40", a_valider: "text-violet-300" };

// Espace membre — « Mon équipement » : Obligatoire / Recommandé / Avancé, statut par article, consignes de taille, conseil taille.
export function MyEquipment() {
  const [data, setData] = useState(null);
  const [ask, setAsk] = useState(false);
  const [msg, setMsg] = useState("");
  const load = () => memberApi.get("/member/equipment").then((r) => setData(r.data)).catch(() => setData(false));
  useEffect(() => { load(); }, []);
  if (!data || !data.has_contract) return null;

  const send = async () => {
    try { await memberApi.post("/member/equipment/size-advice", { message: msg }); toast.success("Demande envoyée — l'équipe te répond au dojo ou par courriel"); setAsk(false); setMsg(""); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };

  return (
    <section className="border border-white/10 p-5 mt-6" data-testid="my-equipment">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="kz-mono text-[10px] tracking-[0.16em] uppercase text-white/40">Mon équipement · {data.program_label}</p>
          <p className="text-sm text-white/70 mt-1">Obligatoire conforme : <b className="text-white" data-testid="my-equipment-progress">{data.progress.conforme}/{data.progress.total}</b></p>
        </div>
        {data.size_request_open
          ? <span className="text-xs text-amber-300" data-testid="my-equipment-size-pending">Demande de conseil taille en cours ✓</span>
          : <button onClick={() => setAsk(true)} className="text-xs border border-white/20 px-3 py-1.5 hover:bg-white hover:text-black transition-colors" data-testid="my-equipment-size-btn">Demander conseil sur ma taille</button>}
      </div>
      {ask && (
        <div className="mt-3 space-y-2" data-testid="my-equipment-size-form">
          <textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={3} placeholder="Ex. : je mesure 1,72 m, 70 kg — quelle taille de short et de gants ?" className="w-full bg-black/40 border border-white/15 p-2 text-sm" data-testid="my-equipment-size-msg" />
          <div className="flex gap-2 justify-end"><button onClick={() => setAsk(false)} className="text-xs px-3 py-1.5 border border-white/10">Annuler</button><button onClick={send} className="text-xs px-3 py-1.5 bg-[#D90429] text-white font-bold" data-testid="my-equipment-size-send">Envoyer ma demande</button></div>
        </div>
      )}
      {data.todo_before_next_class.length > 0 && (
        <div className="mt-3 border border-[#F59E0B]/40 bg-[#F59E0B]/10 p-3 text-sm" data-testid="my-equipment-todo">
          <b className="text-[#F59E0B]">Avant mon prochain cours :</b> {data.todo_before_next_class.join(" · ")}
        </div>
      )}
      <div className="grid md:grid-cols-3 gap-4 mt-4">
        {data.groups.map((g) => (
          <div key={g.category} data-testid={`my-equipment-${g.category}`}>
            <div className={`text-xs font-bold uppercase mb-1 ${g.category === "obligatoire" ? "text-[#F59E0B]" : g.category === "recommande" ? "text-white/70" : "text-sky-300"}`}>{g.label}</div>
            {g.items.length === 0 && <p className="text-xs text-white/30">—</p>}
            <ul className="space-y-1.5">
              {g.items.map((it) => (
                <li key={it.id} className="text-sm" data-testid={`my-equipment-item-${it.id}`}>
                  <span className="text-white/85">{it.label}</span>
                  {it.student_status && <span className={`ml-2 text-[11px] ${CLS[it.student_status]}`}>· {LABEL[it.student_status]}</span>}
                  {(it.sizes?.length > 0 || it.colors?.length > 0) && <div className="text-[11px] text-white/40">{it.colors?.length ? `Couleurs : ${it.colors.join(" / ")}` : ""}{it.colors?.length && it.sizes?.length ? " · " : ""}{it.sizes?.length ? `Tailles : ${it.sizes.join(", ")}` : ""}</div>}
                  {it.reason && <div className="text-[11px] text-white/35 italic">{it.reason}</div>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-white/40 mt-4" data-testid="my-equipment-size-notice">{data.size_notice}</p>
    </section>
  );
}
